import React, { memo } from "react";
import {
	Controller,
	ControllerRenderProps,
	FieldPathValue,
	useFormContext,
	Validate,
} from "react-hook-form";

import AddressSearchInput, {
	AddressSearchInputProps,
} from "./addressSearchInput";

type HookFormProps = {
	validate?:
		| Validate<FieldPathValue<any, any>, any>
		| Record<string, Validate<FieldPathValue<any, any>, any>>;
};

const AddressSearchInputHookForm = ({
	name,
	validate,
	onBlur,
	onSelect,
	onInputChange,
	...props
}: AddressSearchInputProps & HookFormProps) => {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			rules={{ validate: validate }}
			control={control}
			render={({ field }: { field: ControllerRenderProps }) => (
				<AddressSearchInput
					name={name}
					onBlur={(
						e?: React.FocusEvent<HTMLInputElement, Element>,
					) => {
						onBlur?.(e);
						field.onBlur();
					}}
					onInputChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						onInputChange?.(e);
						field.onChange(e.target.value);
					}}
					onSelect={(addressDetails: { [key: string]: any }) => {
						onSelect?.(addressDetails);
						field.onChange(addressDetails);
					}}
					inputRef={field.ref}
					hookFormValue={
						field.value?.label ||
						(typeof field.value === "string" ? field.value : "")
					}
					{...props}
				/>
			)}
		/>
	);
};

export default memo(AddressSearchInputHookForm);
